
// const WebSever = 'http://localhost/Saichha';
const WebSever = '';

const httpClient = {
    WebSever
}

export default httpClient;